import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  BulkDeleteButton,
  Toolbar,
  SaveButton,
  DeleteButton,
  required,
  ArrayInput,
  SimpleFormIterator,
  FormDataConsumer,
  usePermissions,
  useRecordContext,
  SelectInput,
  Filter,
  useNotify,
  ListButton,
} from 'react-admin';

import { SimpleSearchFilter as SearchFilter } from '../../../components/SearchInputSimple';
import { sectionChoices } from '../../../helpers/sectionChoices';
import {
  Text,
  Number,
  RichText,
  Image,
  File,
  Boolean,
  Date,
  ImageOne,
  FileOne,
} from './Fields';

const choices = sectionChoices({
  Text,
  Number,
  RichText,
  Image,
  File,
  Boolean,
  Date,
  ImageOne,
  FileOne,
});

const CriarSecoesTitle = () => {
  const record = useRecordContext();
  if (!record) return null;

  return <span>Seção {record ? `"${record.title}"` : ''}</span>;
}; 

const SecoesFilter = (props) => (
  <SearchFilter {...props} />
);

const PostBulkActionButtons = ({ permissions, ...props }) => (
  <>
    {!permissions.isLoading &&
      permissions.permissions.includes('SYS_ADMIN') && (
        <BulkDeleteButton {...props} />
      )}
  </>
);

export const CriarSecoes = (props) => {
  const permissions = usePermissions();

  return (
    <List
      perPage={25}
      title="Criar Seções (ADMIN)"
      filters={<SecoesFilter />}
      {...props}
    >
      <Datagrid
        bulkActionButtons={<PostBulkActionButtons permissions={permissions} />}
      >
        <TextField label="ID" source="id" />
        <TextField label="Título" source="title" />
        <TextField label="Descrição" source="description" />
        {!permissions.isLoading &&
          permissions.permissions.includes('SYS_ADMIN') && <EditButton />}
      </Datagrid>
    </List>
  );
};

const CustomToolbar = ({ permissions, ...props }) => (
  <Toolbar
    {...props}
    className="botoesUpdate"
    style={{ justifyContent: 'space-between' }}
  >
    <div
      style={{
        width: '250px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <SaveButton alwaysEnable />
      <ListButton
        size="medium"
        variant="outlined"
        label="cancelar"
        icon={<CloseIcon />}
      />
    </div>
    {permissions &&
      permissions.permissions &&
      permissions.permissions.includes('SYS_ADMIN') && (
        <DeleteButton size="medium" />
      )}
  </Toolbar>
);

export const CriarSecoesEdit = (props) => {
  const permissions = usePermissions();
  const notify = useNotify();
  const onError = (data) => {
    notify(data.message);
  };

  return (
    <Edit redirect="list" title={<CriarSecoesTitle />} {...props}>
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <TextInput source="title" label="Nome da Seção" validate={required()} />
        <TextInput
          source="description"
          label="Descrição"
          validate={required()}
          fullWidth
        />
        <ArrayInput source="data_type" label="Campos">
          <SimpleFormIterator>
            <SelectInput
              source="field"
              label="Campo"
              choices={choices}
              validate={required()}
            >
              <TextField source="name" validate={required()} />
            </SelectInput>
            <TextInput
              source="key"
              label="Chave"
              validate={required()}
              format={(value) =>
                value?.replace(/[^A-Z0-9_-]/gi, '').toLowerCase()
              }
            />
            <TextInput
              source="label"
              label="Label (Tooltip)"
              validate={required()}
            />
            <FormDataConsumer>
              {({ getSource, scopedFormData }) => {
                // Pro react admin comer aquele calaboquitos
                // Ele ficava dando warning que não estava usando o getSource
                // e que isso iria fazer os inputs dentro do FormDataConsumer
                // pegar o valor do campo corretamente.
                getSource('field');

                if (!scopedFormData) {
                  return (
                    <div style={{ margin: '5px 0 20px 0', color: 'grey' }}>
                      Selecione um tipo para ter uma pré-visualização
                    </div>
                  );
                }

                const selectedChoice = choices.find(
                  (c) => c.id === scopedFormData.field,
                );

                if (!selectedChoice) {
                  return (
                    <div style={{ margin: '5px 0 20px 0', color: 'grey' }}>
                      Selecione um tipo para ter uma pré-visualização
                    </div>
                  );
                }

                return <selectedChoice.element />;
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export const CriarSecoesCreate = (props) => {
  const permissions = usePermissions();
  const notify = useNotify();
  const onError = (data) => {
    notify(data.message);
  };

  return (
    <Create redirect="list" {...props} title="Nova Seção">
      <SimpleForm toolbar={<CustomToolbar permissions={permissions} />}>
        <TextInput source="title" label="Nome da Seção" validate={required()} />
        <TextInput
          source="description"
          label="Descrição"
          validate={required()}
          fullWidth
        />
        <ArrayInput source="data_type" label="Campos">
          <SimpleFormIterator>
            <SelectInput
              source="field"
              label="Campo"
              choices={choices}
              validate={required()}
            >
              <TextField source="name" validate={required()} />
            </SelectInput>
            <TextInput
              source="key"
              label="Chave"
              validate={required()}
              format={(value) =>
                value?.replace(/[^A-Z0-9_-]/gi, '').toLowerCase()
              }
            />
            <TextInput
              source="label"
              label="Label (Tooltip)"
              validate={required()}
            />
            <FormDataConsumer>
              {({ getSource, scopedFormData }) => {
                // Pro react admin comer aquele calaboquitos
                // Ele ficava dando warning que não estava usando o getSource
                // e que isso iria fazer os inputs dentro do FormDataConsumer
                // pegar o valor do campo corretamente.
                getSource('field');

                if (!scopedFormData) {
                  return (
                    <div style={{ margin: '5px 0 20px 0', color: 'grey' }}>
                      Selecione um tipo para ter uma pré-visualização
                    </div>
                  );
                }

                const selectedChoice = choices.find(
                  (c) => c.id === scopedFormData.field,
                );

                if (!selectedChoice) {
                  return (
                    <div style={{ margin: '5px 0 20px 0', color: 'grey' }}>
                      Selecione um tipo para ter uma pré-visualização
                    </div>
                  );
                }

                return <selectedChoice.element />;
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default CriarSecoes;
